import { useMemo } from 'react';
import { useMsal } from '@azure/msal-react';
import { createApiClient, type ApiClient } from './api';

/**
 * An API client bound to the signed-in account, or null when nobody is signed
 * in. Memoised on the account's home id so the client is stable across
 * renders — a new client object every render would restart every effect that
 * depends on it.
 */
export function useApi(): ApiClient | null {
  const { instance, accounts } = useMsal();
  const account = instance.getActiveAccount() ?? accounts[0] ?? null;

  return useMemo(
    () => (account ? createApiClient(instance, account) : null),
    [instance, account?.homeAccountId]
  );
}
